import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MapContainer, TileLayer, Marker, Popup, Polyline } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import './MapView.css';

// Fix for default marker icons in React-Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const MapView = ({ user, onLogout }) => {
  const navigate = useNavigate();
  const [selectedVehicle, setSelectedVehicle] = useState(null);

  // Posiciones simuladas de vehículos (Santiago, Chile como referencia)
  const vehicles = [
    { 
      id: 1, 
      plate: 'ABC-123', 
      driver: 'Juan Pérez', 
      position: [-33.4489, -70.6693],
      speed: 45,
      status: 'En movimiento',
      route: [[-33.4489, -70.6693], [-33.4500, -70.6700], [-33.4520, -70.6710]]
    },
    { 
      id: 2, 
      plate: 'DEF-456', 
      driver: 'María García', 
      position: [-33.4372, -70.6506],
      speed: 0,
      status: 'Detenido',
      route: [[-33.4372, -70.6506]]
    },
    { 
      id: 3, 
      plate: 'GHI-789', 
      driver: 'Pedro López', 
      position: [-33.4569, -70.6483],
      speed: 60,
      status: 'En movimiento',
      route: [[-33.4569, -70.6483], [-33.4580, -70.6490], [-33.4600, -70.6500]]
    }
  ];

  const pointsOfInterest = [
    { id: 1, name: 'Base Central', position: [-33.4372, -70.6506], type: 'base' },
    { id: 2, name: 'Mina Norte', position: [-33.4200, -70.6000], type: 'mine' },
    { id: 3, name: 'Estación de Servicio', position: [-33.4600, -70.6700], type: 'fuel' }
  ];

  return (
    <div className="map-view">
      <nav className="navbar">
        <div className="nav-brand">🚚 Fleet Monitor</div>
        <div className="nav-user">
          <span>{user.name}</span>
          <button onClick={onLogout} className="btn-logout">Salir</button>
        </div>
      </nav>

      <div className="map-container">
        <aside className="map-sidebar">
          <button className="menu-item" onClick={() => navigate('/dashboard')}>
            📊 Dashboard
          </button>
          <button className="menu-item active">
            🗺️ Mapa en Tiempo Real
          </button>
          <button className="menu-item" onClick={() => navigate('/history')}>
            📜 Historial
          </button>
          <button className="menu-item" onClick={() => navigate('/reports')}>
            📈 Reportes
          </button>
          {user.role === 'admin' && (
            <button className="menu-item" onClick={() => navigate('/users')}>
              👥 Usuarios
            </button>
          )}

          <div className="vehicle-list">
            <h3>Vehículos Activos</h3>
            {vehicles.map(vehicle => (
              <div 
                key={vehicle.id} 
                className={`vehicle-item ${selectedVehicle?.id === vehicle.id ? 'selected' : ''}`}
                onClick={() => setSelectedVehicle(vehicle)}
              >
                <div className="vehicle-info">
                  <strong>{vehicle.plate}</strong>
                  <small>{vehicle.driver}</small>
                </div>
                <div className={`vehicle-status ${vehicle.status === 'En movimiento' ? 'active' : 'stopped'}`}>
                  {vehicle.speed} km/h
                </div>
              </div>
            ))}
          </div>

          <div className="poi-list">
            <h3>Puntos de Interés</h3>
            {pointsOfInterest.map(poi => (
              <div key={poi.id} className="poi-item">
                <span>{poi.type === 'base' ? '🏢' : poi.type === 'mine' ? '⛏️' : '⛽'}</span>
                <span>{poi.name}</span>
              </div>
            ))}
          </div>
        </aside>

        <div className="map-content">
          <MapContainer 
            center={[-33.4489, -70.6693]} 
            zoom={13} 
            style={{ height: '100%', width: '100%' }}
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />
            
            {vehicles.map(vehicle => (
              <React.Fragment key={vehicle.id}>
                <Marker position={vehicle.position}>
                  <Popup>
                    <div className="popup-content">
                      <h4>{vehicle.plate}</h4>
                      <p><strong>Conductor:</strong> {vehicle.driver}</p>
                      <p><strong>Velocidad:</strong> {vehicle.speed} km/h</p>
                      <p><strong>Estado:</strong> {vehicle.status}</p>
                    </div>
                  </Popup>
                </Marker>
                {vehicle.route.length > 1 && (
                  <Polyline 
                    positions={vehicle.route} 
                    color="blue" 
                    weight={3}
                    opacity={0.6}
                  />
                )}
              </React.Fragment>
            ))}

            {pointsOfInterest.map(poi => (
              <Marker 
                key={poi.id} 
                position={poi.position}
                icon={L.divIcon({
                  html: `<div style="background: red; width: 20px; height: 20px; border-radius: 50%;"></div>`,
                  className: 'custom-marker'
                })}
              >
                <Popup>
                  <h4>{poi.name}</h4>
                  <p>Tipo: {poi.type}</p>
                </Popup>
              </Marker>
            ))}
          </MapContainer>
        </div>
      </div>
    </div>
  );
};

export default MapView;
